import React from "react";
import FeedStory from "../feedStory/feedStory";
import { useRssFetch } from "../../custom-hooks/useRssFetch";
import LoadSpinner from "../loadSpinner/LoadSpinner";
import type { FeedItem, Story } from "../../types/rss";

export interface CnnFeedProps {
  /** Path segment identifying which feed to load. */
  urlStub: string;
}

const CnnFeed = (props: CnnFeedProps) => {
  const feed = useRssFetch(`http://rss.cnn.com/rss/${props.urlStub}.rss`);

  if (!feed || !feed.items) {
    return <LoadSpinner />;
  }
  const stories: Story[] = [];
  feed.items.forEach(function (entry: FeedItem) {
    const mediaContent = entry.media ? entry.media[0]["media:content"] : null;

    stories.push({
      name: entry.title ?? "",
      url: entry.link ?? "",
      img: mediaContent?.[0]?.$?.url ?? ""
    });
  });

  return (
    <div className="cnn-feed">
      {stories.map((story, i) => {
        return <FeedStory key={i} story={story} shouldShowImage={i === 0} />;
      })}
    </div>
  );
};

export default React.memo(CnnFeed);
